import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue'
import BKBadge from '@/components/AppShared/BKBadge.vue'
import { mdiCheck, mdiHelp } from '@mdi/js'
import { useImage } from '@/shared/composables/image'
import { BattleParticipant } from '@/enitites/battle/model/types'
import { IEvent } from '@/enitites/event'


export default /*#__PURE__*/_defineComponent({
  __name: 'BattleParticipantRow',
  props: {
    participant: null,
    isHighlighted: { type: Boolean },
    event: null
  },
  setup(__props: any) {

const props = __props as {
  participant: BattleParticipant
  isHighlighted?: boolean
  event: IEvent
};



const { getAvatar, getStudioImage } = useImage()
const isShowActions = ref(false)

const isParticipantConfirmed = computed(() => {
  const date = props.participant.confirmedAt
  return date instanceof Date ? date.getFullYear() > 2000 : new Date(date).getFullYear() > 2000
})

const isParticipantCheckedIn = computed(() => {
  const date = props.participant.checkedInAt
  return date instanceof Date ? date.getFullYear() > 2000 : new Date(date).getFullYear() > 2000
})

const getBadgeColor = computed(() => {
  let color
  if (isParticipantCheckedIn.value) {
    color = 'var(--color-green)'
  }

  if (!isParticipantConfirmed.value) {
    color = 'var(--color-orange-500)'
  }

  return color
})

return { __sfc: true,props, getAvatar, getStudioImage, isShowActions, isParticipantConfirmed, isParticipantCheckedIn, getBadgeColor, BKBadge, mdiCheck, mdiHelp }
}

})